<div *ngIf="docItems else docitemloading">

  <app-confirm-delete-product-part [(display)]="confirmDeleteOn"
                                   [typeConfirmation]="typeDeleteConfirmation"
                                   [confirmText]="confirmText"
                                   (done)="onDeleteConfirmation($event)"></app-confirm-delete-product-part>

  <p-table #docItemTable [value]="docItems"
           dataKey="DOCITEMID"
           [loading]="loading"
           selectionMode="multiple"
           [(selection)]="sDI"
           (onRowSelect)="onRowSelect($event)"
           [rowHover]="true"
           [resizableColumns]="true"
           (onStateSave)="onStateSave($event)"
           (onStateRestore)="onStateRestore($event)"
           editMode="row"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped">
    <ng-template pTemplate="caption" *ngIf="showHeader">
      <div class="grid vertical-container">
        <div class="col align-self-start">
          <div class="grid p-jc-start mt-1">
            <!--<p-selectButton [options]="showDocRowsOptions" [(ngModel)]="showRowOptions"
                          multiple="multiple" optionLabel="name" optionValue="value" optionDisabled="disabled"
                          (onChange)="onRowsOptionChange($event)" styleClass="mr-2 mt-2"
                          pTooltip="Показывать дополнительные поля документа" tooltipPosition="top">
          </p-selectButton>-->
            <!--<p-dropdown [options]="serialStrings"
                      [(ngModel)]="serialStr"
                      class="p-button-help xl:col-3 ml-2 mr-1"
                      [disabled]="noItems || editMode"
                      [autofocus]="true"
                      (keyup.enter)="onKeyPress($event)"
                      (keydown)="$event.stopPropagation()"
                      placeholder="Сканируйте или введите серийный номер"
                      [filter]="true"
                      filterPlaceholder="Найти по номеру..."
                      (onChange)="onEnterSerial($event)"
                      (onClear)="onClearSerial($event)"
                      [showClear]="true"
                      [editable]="true"
                      [autofocusFilter]="false"
                      pTooltip="Серийный номер (Enter вставит в документ)"
                      tooltipPosition="top">

            <ng-template let-serial pTemplate="item">
              <div [class.missed]="notIn(serial)">
                {{serial}}
              </div>
            </ng-template>

          </p-dropdown>-->

            <p-inputGroup class="xl:col-4">
              <input type="text" pInputText [(ngModel)]="serialStr"
                     class="p-button-help ml-2 mr-1"
                     [style]="{'width':'60%'}"
                     (keyup.enter)="onKeyPress($event)"
                     (keydown)="$event.stopPropagation()"
                     placeholder="Сканируйте или введите серийный номер"
                     pTooltip="Серийный номер (Enter вставит в документ)"
                     tooltipPosition="top" />

              <button type="button" pButton icon="pi pi-check" class="p-button-success" (click)="onKeyPress($event)" pTooltip="Вставить" tooltipPosition="top" [disabled]="serialStr===''"></button>
              <button type="button" pButton icon="pi pi-times" class="p-button-danger" (click)="onClearSerial($event)" pTooltip="Очистить" tooltipPosition="top" [disabled]="serialStr===''"></button>
            </p-inputGroup>

            <p-dropdown [options]="products"
                        [dataKey]="prodid"
                        [(ngModel)]="serialProdId"
                        optionLabel="prodname"
                        optionValue="prodid"
                        class="xl:col-4 mr-1"
                        [disabled]="noItems || editMode"
                        [autoDisplayFirst]="false"
                        [showClear]="true"
                        (onChange)="onSelectedItemChange($event)"
                        placeholder="Выбрать товар..."
                        [filter]="true"
                        filterPlaceholder="Найти по коду..."
                        pTooltip="Товары в документе {{serialProdId}}"
                        tooltipPosition="top"
                        (keydown)="$event.stopPropagation()"></p-dropdown>

            <p-button icon="pi pi-check" styleClass="p-button-success mr-4 mt-1 hide-label" [disabled]="!canSearchAndInsert" (onClick)="searchAndInsert($event)"
                      pTooltip="Найти и вставить серийный номер" tooltipPosition="top"></p-button>

            <p-button icon="pi pi-list" styleClass="p-button-info mr-4 mt-1 hide-label" [disabled]="!canSearch" (onClick)="onSelectAllItems($event)"
                      pTooltip="Выбрать все товары в списке" tooltipPosition="top"></p-button>

            <p-checkbox [(ngModel)]="enableDuplicate" [binary]="true" label="Разрешить дубликаты"></p-checkbox>

          </div>
        </div>
        <div class="col align-self-end">
          <div class="grid justify-content-end mt-2">
            <p-button icon="pi pi-sort" styleClass="p-button-secondary mr-2 hide-label" [disabled]="noItems || editMode" (onClick)="cleanSortMode($event)"
                      pTooltip="Убрать сортировку" tooltipPosition="top"></p-button>

            <p-button icon="pi pi-times" styleClass="p-button-warning mr-2 hide-label" [disabled]="noItems || editMode" (onClick)="clearSerialFields($event)"
                      pTooltip="Убрать все серийные номера" tooltipPosition="top"></p-button>

            <p-dropdown [options]="warrantyOptionsList" [(ngModel)]="warranty" class="" [disabled]="noItems || editMode"
                        editable="true" pTooltip="Гарантия (срок, условия)" tooltipPosition="top"></p-dropdown>
            <p-button icon="pi pi-clock" styleClass="p-button-success mr-4 hide-label" [disabled]="noItems || editMode" (onClick)="updateWarrantyTerms($event)"
                      pTooltip="Обновить/установить гарантию выбранных позиций" tooltipPosition="top"></p-button>

            <p-button label="Нумеровать" icon="pi pi-sort-numeric-down" styleClass="p-button-success mr-4 hide-label" [disabled]="noItems || editMode" (onClick)="updateRowIndexes($event)"
                      pTooltip="Обновить индексы строк в документе" tooltipPosition="top"></p-button>

            <p-button label="Обновить" icon="pi pi-refresh" (onClick)="reloadDocContent($event)" styleClass="p-button-success ml-2 mr-2 hide-label" [disabled]="editMode"
                      pTooltip="Обновить содержимое таблицы" tooltipPosition="top"></p-button>
            <p-button label="XLSX" icon="pi  pi-file-excel" styleClass="p-button-info mr-2 hide-label" (onClick)="onExportData()"
                      pTooltip="Экспортировать содержимое документа" tooltipPosition="top" [disabled]="noItems || editMode"></p-button>
          </div>
        </div>
      </div>

      <div class="grid" *ngIf="allowEditControls && tooMuchItems">
        <div class="col">
          <div class="grid formgrid p-jc-start">
            <p-button label="Добавить строку" icon="pi pi-plus" (onClick)="onAddRow($event)" styleClass="ml-2 mt-2 mr-2" [disabled]="editMode"
                      pTooltip="Добавить новую строку" tooltipPosition="top"></p-button>
          </div>
        </div>
        <div class="col">
          <div class="grid formgrid justify-content-end">
            <p-button label="Выбрать все" icon="pi pi-plus" (onClick)="onSelectAll($event)" styleClass="p-button-info mt-2 mr-2" [disabled]="editMode || noItems"
                      pTooltip="Выбор всех строк" tooltipPosition="top"></p-button>
            <p-button label="Отменить выбор" icon="pi pi-minus" (onClick)="onRemoveSelection($event)" styleClass="p-button-info mt-2 mr-2" [disabled]="editMode || !selection"
                      pTooltip="Отменить выбор всех строк" tooltipPosition="top"></p-button>
            <p-button label="Удалить все строки" icon="pi pi-trash" (onClick)="onRemoveAllRow($event)" styleClass="p-button-danger mt-2 mr-2" [disabled]="editMode || noItems"
                      pTooltip="Убрать все строки" tooltipPosition="top"></p-button>
            <p-button label="Удалить строку ({{sDI.length}})" icon="pi pi-minus" (onClick)="onRemoveRow($event)" styleClass="p-button-warning mt-2 mr-2" [disabled]="editMode || !selection"
                      pTooltip="Убрать выбранные строки ({{sDI.length}})" tooltipPosition="top"></p-button>
          </div>
        </div>
      </div>

    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th style="width: 7rem" *ngIf="allowEditControls">
          <div class="col align-self-start">
            <p-selectButton [options]="showFilterOptions" [(ngModel)]="showFilterValue" multiple="multiple" optionValue="value" optionDisabled="disabled" optionLabel="icon"
                            pTooltip="Показывать фильтр по полям таблицы" tooltipPosition="top">
              <ng-template let-item pTemplate>
                <i [class]="item.icon"></i>
              </ng-template>
            </p-selectButton>
          </div>
        </th>
        <th pSortableColumn="PRODCODE" style="width:25%" pResizableColumn>Код товара <p-sortIcon field="PRODCODE"></p-sortIcon></th>
        <th pSortableColumn="PRODCUSTCODE" style="width:8rem" pResizableColumn *ngIf="seeTariffCode">Код УКТЗЕД <p-sortIcon field="PRODCUSTCODE"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMPRODNAME" style="width:35%" pResizableColumn>Название товара <p-sortIcon field="DOCITEMPRODNAME"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMQTY" style="width:7rem" pResizableColumn>Количество <p-sortIcon field="DOCITEMQTY"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMTEXT1" style="width:35%" pResizableColumn>Серийный номер <p-sortIcon field="DOCITEMTEXT1"></p-sortIcon></th>
        <th pSortableColumn="DOCITEMTEXT2" style="width:35%" pResizableColumn>{{lblDOCITEMTEXT2}} <p-sortIcon field="DOCITEMTEXT2"></p-sortIcon></th>
        <th pSortableColumn="PAYITEMCLIID" style="width:5rem" pResizableColumn># <p-sortIcon field="PAYITEMCLIID"></p-sortIcon></th>
        <th style="width: 3rem"></th>
      </tr>

      <tr *ngIf="showFilter">
        <th pResizableColumn style="width: 7rem" *ngIf="allowEditControls">Фильтр =></th>

        <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['PRODCODE']" [class.hasvalue]="cf3['PRODCODE']" (input)="docItemTable.filter($event.target.value, 'PRODCODE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn *ngIf="seeTariffCode"><input pInputText type="text" [(ngModel)]="cf3['PRODCUSTCODE']" [class.hasvalue]="cf3['PRODCUSTCODE']" (input)="docItemTable.filter($event.target.value, 'PRODCUSTCODE', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['DOCITEMPRODNAME']" [class.hasvalue]="cf3['DOCITEMPRODNAME']" (input)="docItemTable.filter($event.target.value, 'DOCITEMPRODNAME', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['DOCITEMQTY']" [class.hasvalue]="cf3['DOCITEMQTY']" (input)="docItemTable.filter($event.target.value, 'DOCITEMQTY', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['DOCITEMTEXT1']" [class.hasvalue]="cf3['DOCITEMTEXT1']" (input)="docItemTable.filter($event.target.value, 'DOCITEMTEXT1', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['DOCITEMTEXT2']" [class.hasvalue]="cf3['DOCITEMTEXT2']" (input)="docItemTable.filter($event.target.value, 'DOCITEMTEXT2', 'contains')" placeholder="Поиск" class="p-column-filter"></th>
        <th pResizableColumn><input pInputText type="text" [(ngModel)]="cf3['PAYITEMCLIID']" [class.hasvalue]="cf3['PAYITEMCLIID']" (input)="docItemTable.filter($event.target.value, 'PAYITEMCLIID', 'GteOrZero')" placeholder="Поиск" class="p-column-filter"></th>

        <th pResizableColumn style="width: 3rem">...</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-docItem let-editing="editing" let-ri="rowIndex">
      <tr [pSelectableRow]="docItem" [pEditableRow]="docItem">

        <td *ngIf="allowEditControls">
          <button *ngIf="!editing && !editMode" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" (click)="onDiRowEditInit(docItem)" class="p-button-rounded p-button-text"></button>
          <button *ngIf="editing" [disabled]="!allowSave(docItem)" pButton pRipple type="button" pSaveEditableRow icon="pi pi-save" (click)="onDiRowEditSave(docItem)" class="p-button-rounded p-button-text p-button-success mr-2"></button>
          <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" (click)="onDiRowEditCancel(docItem, ri)" class="p-button-rounded p-button-text p-button-danger"></button>
        </td>

        <td style="overflow: visible !important; ">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <app-productselector [showLabel]="false" [searchText]="docItem.PRODCODE" [allowOld]="allowOld" (selectedProduct)="onProductSelection($event, docItem)" [style]="{'width':'60%'}"></app-productselector>
            </ng-template>
            <ng-template pTemplate="output">
              <div class="align-self-baseline" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                <a [routerLink]="['/edit-product', docItem.PRODID]">{{docItem.PRODCODE}}</a>
              </div>
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; background-color:ghostwhite" *ngIf="seeTariffCode">{{docItem.PRODCUSTCODE}}</td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="docItem.DOCITEMPRODNAME" [style]="{'width':'100%'}" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              <input pInputText type="text" [(ngModel)]="docItem.DOCITEMPRODNAME" [style]="{'width':'100%'}" readonly alt="{{docItem.DOCITEMPRODNAME}}">
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="docItem.DOCITEMQTY" [style]="{'width':'100%'}" step="1" style="text-align: right"
                     (change)="onDOCITEMQTYChange($event, docItem)" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">
              <span [class.shipped]="docItem.sha" [class.missed]="docItem.mst">{{docItem.DOCITEMQTY | number:'1.0-2'}}</span>
            </ng-template>
          </p-cellEditor>
        </td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="docItem.DOCITEMTEXT1" [style]="{'width':'100%'}" (keyup.enter)="onDOCITEMTEXT1EnterKeyPress($event, docItem)" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">{{docItem.DOCITEMTEXT1}}</ng-template>
          </p-cellEditor>
        </td>

        <td style="overflow: visible !important; ">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <p-dropdown [options]="warrantyOptionsList" [(ngModel)]="docItem.DOCITEMTEXT2" [style]="{'width':'100%'}"
                          editable="true" pTooltip="Гарантия (срок, условия)" tooltipPosition="top" (keydown)="$event.stopPropagation()"></p-dropdown>
            </ng-template>
            <ng-template pTemplate="output"><span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">{{docItem.DOCITEMTEXT2}}</span></ng-template>
          </p-cellEditor>
        </td>

        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="docItem.PAYITEMCLIID" [style]="{'width':'100%'}" min="0" step="10" style="text-align: right" (change)="onPAYITEMCLIIDChange($event, docItem)" (keydown)="$event.stopPropagation()">
            </ng-template>
            <ng-template pTemplate="output">{{docItem.PAYITEMCLIID | number:'1.0-0'}}</ng-template>
          </p-cellEditor>
        </td>

        <td>
          <button *ngIf="!docItem.hlt" pButton pRipple type="button" icon="pi pi-check" (click)="checkDiState($event, docItem)" class="p-button-rounded p-button-success p-button-text"></button>
          <button *ngIf="docItem.hlt" pButton pRipple type="button" icon="pi pi-exclamation-triangle" (click)="checkDiState($event, docItem)" class="p-button-rounded p-button-danger p-button-text"></button>
        </td>

        <ng-template #waiting>
          <span>---</span>
        </ng-template>

      </tr>
    </ng-template>

    <ng-template pTemplate="footer" *ngIf="inputDocument as doc">
      <tr>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right" *ngIf="allowEditControls">{{doc.DOCITEMS | number:'1.0-2'}}</td>
        <td></td>
        <td *ngIf="seeTariffCode"></td>
        <td></td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; text-align: right">{{doc.DOCTOTALITEMS | number:'1.0-2'}}</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </ng-template>

    <ng-template pTemplate="summary">
      <div class="grid" *ngIf="allowEditControls">
        <div class="col">
          <div class="grid formgrid p-jc-start">
            <p-button label="Добавить строку" icon="pi pi-plus" (onClick)="onAddRow($event)" styleClass="p-button-success ml-2 mt-2 mr-2" [disabled]="editMode"
                      pTooltip="Добавить новую строку" tooltipPosition="top"></p-button>
          </div>
        </div>
        <div class="col">
          <div class="grid formgrid justify-content-end">
            <p-button label="Выбрать все" icon="pi pi-plus" (onClick)="onSelectAll($event)" styleClass="p-button-info mt-2 mr-2" [disabled]="editMode || noItems"
                      pTooltip="Выбор всех строк" tooltipPosition="top"></p-button>
            <p-button label="Отменить выбор" icon="pi pi-minus" (onClick)="onRemoveSelection($event)" styleClass="p-button-info mt-2 mr-2" [disabled]="editMode || !selection"
                      pTooltip="Отменить выбор всех строк" tooltipPosition="top"></p-button>
            <p-button label="Удалить все строки" icon="pi pi-trash" (onClick)="onRemoveAllRow($event)" styleClass="p-button-danger mt-2 mr-2" [disabled]="editMode || noItems"
                      pTooltip="Убрать все строки" tooltipPosition="top"></p-button>
            <p-button label="Удалить строку ({{sDI.length}})" icon="pi pi-minus" (onClick)="onRemoveRow($event)" styleClass="p-button-warning mt-2 mr-2" [disabled]="editMode || !selection"
                      pTooltip="Убрать выбранные строки ({{sDI.length}})" tooltipPosition="top"></p-button>
          </div>
        </div>
      </div>

      <div class="fluid formgrid grid" *ngIf="inputDocument as doc">
        <div class="field col-12 xl:col-1 sm:col-4">
          <label for="DS1" class="do-not-wrap-text">Количество позиций</label>
          <p-inputNumber id="DS1" [(ngModel)]="doc.DOCITEMS" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
        <div class="field col-12 xl:col-1 sm:col-4">
          <label for="DS2" class="do-not-wrap-text">Общее количество</label>
          <p-inputNumber id="DS2" [(ngModel)]="doc.DOCTOTALITEMS" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [disabled]="true"></p-inputNumber>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">Пустой документ</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #docitemloading>
  <p>Содержимое документа загружается...</p>
</ng-template>
